import React from 'react'
import { ProgressBarSteps } from 'src/Libs/shop/types'
import { useShopQntmSystemConfigurationCard } from '../hooks/use-shop-qntm-system-configuration'
import SystemConfigurationCard from '../../SystemConfigurationCard'

interface QntmSystemConfigurationCardProps {
  showMobile: boolean
  progress: number
  onClose: () => void
  navigateTo: (page: ProgressBarSteps) => void
}

/*
 * Wrapper for system configuration summary card using quantum configuration data
 */
const QntmSystemConfigurationCard: React.FC<QntmSystemConfigurationCardProps> = ({ showMobile, progress, onClose, navigateTo }) => {
  const {
    basicData,
    deliveryDate,
    selectedMainComponents,
    selectedWarrantyExtensionId,
    mainComponent,
    totalPrice,
    discountedPrice,
    basicSystemImageUrl,
  } = useShopQntmSystemConfigurationCard()

  return (
    <SystemConfigurationCard
      showMobile={showMobile}
      progress={progress}
      onClose={onClose}
      navigateTo={navigateTo}
      deliveryDate={deliveryDate}
      selectedWarrantyExtensionId={selectedWarrantyExtensionId}
      selectedMainComponents={selectedMainComponents}
      basicData={basicData}
      mainComponent={mainComponent}
      totalPrice={totalPrice}
      discountedPrice={discountedPrice}
      basicSystemImageUrl={basicSystemImageUrl}
    />
  )
}

export default QntmSystemConfigurationCard
